import {defineStore} from 'pinia';
import axios from "axios";
import type {Order, OrderState} from "~/types/Order";

export const useOrderStore = defineStore('order', {
    state: () => ({
        orderStates: [] as OrderState[],
        _fetchOrdersPromise: null as Promise<any> | null,
    }),
    actions: {
        async store({productId, accessToken, token, rcaOfferId, travelOfferId, houseInsuranceOfferIds, rcaVerifyOfferCode, partnerCode, hasRoadAssistance}: {
            productId: number;
            accessToken: string;
            token?: string;
            rcaOfferId?: number;
            travelOfferId?: number;
            houseInsuranceOfferIds?: number[];
            rcaVerifyOfferCode?: string;
            partnerCode?: string;
            hasRoadAssistance?: boolean;
        }) {
            try {
                const response = await axios.post(`${import.meta.env.VITE_API_BASE_URL}/api/v1/orders`, {
                    product_id: productId,
                    token: token ?? undefined,
                    rca_offer_id: rcaOfferId ?? undefined,
                    travel_offer_id: travelOfferId ?? undefined,
                    house_insurance_offer_ids: houseInsuranceOfferIds ?? undefined,
                    rca_verify_offer_code: rcaVerifyOfferCode ?? undefined,
                    partner_code: partnerCode ?? undefined,
                    has_road_assistance: hasRoadAssistance ?? undefined,
                }, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        async fetchPaymentRequest(orderId: number, accessToken: string) {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v1/orders/${orderId}/payment-request`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        async fetchOrderStates(): Promise<OrderState[]> {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v1/orders/states`);
                return response.data.data;
            } catch (error) {
                throw error;
            }
        },
        async getOrderStates() {
            if (this.orderStates.length === 0) {
                this.orderStates = await this.fetchOrderStates();
            }
            return this.orderStates;
        },
        async fetchOrders(accessToken: string): Promise<Order> {
            if (!this._fetchOrdersPromise) {
                this._fetchOrdersPromise = axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v1/orders`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                }).then((response) => {
                    this._fetchOrdersPromise = null;
                    return response.data.data;
                });
            }
            return this._fetchOrdersPromise;
        },
        async fetchOrder(orderCode: string, accessToken: string): Promise<Order> {
            try {
                const response = await axios.get(`${import.meta.env.VITE_API_BASE_URL}/api/v1/orders/${orderCode}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                });
                return response.data.data;
            } catch (error) {
                throw error;
            }
        }
    },
});
